// ENG-3550: the slideout record viewer's browser-history entry. Opening the viewer pushes
// one entry with the same address and this marker in history state, so browser Back
// closes the viewer instead of skipping past it to an older list page. History state, not
// a query param: list pages send their whole query string to the inbox API, so a record
// param would leak into list fetches and count keys.
export const RECORD_VIEWER_STATE_KEY = 'recordViewer';

export const recordViewerEntry = (state) => state?.[RECORD_VIEWER_STATE_KEY] || null;

// file_token alone is not a row identity: on Sent, one document sent to several recipients
// shares a file_token, so send_token is kept alongside it. On Assigned, two assignments of
// one document share both tokens, so the assignment slug is kept too.
export const withRecordViewerEntry = (state, record, tab = null) => ({
  ...(state || {}),
  [RECORD_VIEWER_STATE_KEY]: {
    fileToken: record?.file_token || null,
    sendToken: record?.send_token || null,
    slug: record?.slug || null,
    ...(record?.patient ? { patient: true } : {}),
    ...(['general', 'comments', 'ai_fields'].includes(tab) ? { tab } : {}),
  },
});

export const withoutRecordViewerEntry = (state) => {
  if (!recordViewerEntry(state)) return state;
  const { [RECORD_VIEWER_STATE_KEY]: _removed, ...rest } = state;
  return Object.keys(rest).length ? rest : undefined;
};

export const findRecordViewerRowIndex = (rows, entry) => {
  if (!entry || !Array.isArray(rows)) return -1;
  // An assignment is found by its slug only: falling back to the shared tokens would reopen
  // another person's assignment of the same document.
  if (entry.slug) return rows.findIndex((row) => row?.slug === entry.slug);
  return rows.findIndex((row) => {
    if (!row) return false;
    if (entry.fileToken && row.file_token !== entry.fileToken) return false;
    if (entry.sendToken && row.send_token !== entry.sendToken) return false;
    return Boolean(entry.fileToken || entry.sendToken);
  });
};

// Query strings compared as parameter sets, so `?a=1&b=2` and `?b=2&a=1` (or an encoded
// `status%5B%5D` vs `status[]`) are the same list.
export const sameSearch = (a, b) => {
  const normalize = (search) => {
    const params = new URLSearchParams(String(search || '').replace(/^\?/, ''));
    params.sort();
    return params.toString();
  };
  return normalize(a) === normalize(b);
};
